﻿(function () {
    'use strict';

    var app = angular.module('app.directives');

    app.directive('dirMenubar', function () {
        return {
            restrict: 'AE',
            scope: {
                items: '=menuData'
            },
            templateUrl: 'app/directives/dirMenuBar2.html'
        };
    });

    app.directive('dirToolbar', ['datacontext', '$interpolate', '$compile',
            function (datacontext, $interpolate, $compile) {
                return {
                    restrict: 'AE',
                    replace: true,
                    scope: {
                        toolbarName: '=name'
                    },
                    link: function ($scope, $element, attr) {
                        if (attr.name) {
                            
                            datacontext.security.getToobar(replaceQuotes(attr.name)).then(function (data) {
                                var template = "";
                                angular.forEach(data, function (model, index) {
                                    if (index == 0) {
                                        template = template + "<button type='button' class='btn btn-primary toolbar-btn radius-first-btn' ng-click='$parent.vm." + model.controlName + "()' >" + model.controlText + "</button>";
                                    } else if ((index + 1) == data.length) {
                                        template = template + "<button type='button' class='btn btn-primary toolbar-btn radius-last-btn' ng-click='$parent.vm." + model.controlName + "()' >" + model.controlText + "</button>";
                                    } else {
                                        template = template + "<button type='button' class='btn btn-primary toolbar-btn' ng-click='$parent.vm." + model.controlName + "()' >" + model.controlText + "</button>";
                                    }
                                });


                                var interpolated = $interpolate(template)($scope);
                                var html = $(interpolated);
                                $element.replaceWith($compile(html)($scope));
                            });
                        }

                    }
                };

                function replaceQuotes(text) {
                    return text.replace(/["']/g, "");
                }
            }]);

    app.directive('dirHeader',['$interpolate', '$compile',function ($interpolate, $compile) {
        return {
            restrict: 'E',
            scope: {
                title: '@', //title of page in <strong>
                rigth: '@',  //text or html rigth of title
                bottom: '@',//text or html bottom title (small text)
                icontitle: '@' // icon left of title
            },      
            link: function ($scope, $element, attr) {
                var template = "<section class='page-title'><div class='container'>";

                if (attr.title || attr.left) {
                        
                    template += "<header><h2>";
                    
                    if (attr.title) {
                        if (attr.icontitle) {
                            template += "<div class=" + attr.icontitle + "></div>";
                        }
                        template += "<strong>" + attr.title + "</strong>";
                    }
                    if (attr.left) {
                        template += attr.left;
                    }
                    template += "</h2></header>";
                }       

                if (attr.bottom) {
                    template += "<ul class='breadcrumb'>" + attr.bottom + "</ul>";
                }
                template += "</div></section>";

                var interpolated = $interpolate(template)($scope);
                var html = $(interpolated);
                $element.replaceWith($compile(html)($scope));
            }

        };
    }]);

    //app.directive('ccSpinner', ['$window', function ($window) {
    //    // Description:
    //    //  Creates a new Spinner and sets its options
    //    // Usage:
    //    //  <div data-cc-spinner="vm.spinnerOptions"></div>
    //    var directive = {
    //        link: link,
    //        restrict: 'AE'
    //    };
    //    return directive;

    //    function link(scope, element, attrs) {
    //        scope.spinner = null;
    //        scope.$watch(attrs.ccSpinner, function (options) {
    //            if (scope.spinner) {
    //                scope.spinner.stop();
    //            }
    //            scope.spinner = new $window.Spinner(options);
    //            scope.spinner.spin(element[0]);
    //        }, true);
    //    }
    //}]);

})();
